import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none",
  viewBox: "0 0 48 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2787F5",
      d: "M31.6 3.2H16.4c-6.6 0-9.9 0-11.95 2.05S2.4 10.6 2.4 17.2v15.2c0 6.6 0 9.9 2.05 11.95S9.8 46.4 16.4 46.4h15.2c6.6 0 9.9 0 11.95-2.05S45.6 39 45.6 32.4V17.2c0-6.6 0-9.9-2.05-11.95S38.2 3.2 31.6 3.2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M14.65 17.15h-2.975c-.85 0-1.02.4-1.02.841 0 .788 1.009 4.697 4.697 9.865 2.459 3.53 5.924 5.444 9.076 5.444 1.892 0 2.125-.425 2.125-1.157v-2.668c0-.85.18-1.02.779-1.02.441 0 1.198.22 2.963 1.923 2.018 2.017 2.35 2.922 3.485 2.922h2.976c.85 0 1.275-.425 1.03-1.264-.268-.836-1.232-2.049-2.51-3.486-.694-.82-1.734-1.702-2.05-2.143-.44-.568-.314-.82 0-1.324 0 0 3.626-5.106 4.005-6.84.189-.63 0-1.093-.9-1.093h-2.976c-.756 0-1.105.4-1.295.841 0 0-1.513 3.688-3.656 6.083-.694.694-1.01.914-1.388.914-.189 0-.463-.22-.463-.85v-5.895c0-.756-.22-1.093-.85-1.093h-4.676c-.473 0-.757.351-.757.684 0 .717 1.072.882 1.182 2.9v4.38c0 .96-.173 1.135-.552 1.135-1.008 0-3.462-3.704-4.917-7.942-.286-.824-.572-1.157-1.332-1.157",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }